export default {
    fontFamily: [
        {
            label: 'Default Fonts',
            options: [
                { value: 'Arial', label: 'Arial' },
                { value: 'Georgia', label: 'Georgia' },
            ],
        },
        {
            label: 'Custom',
            options: [
                {
                    value: 'CustomFontsCTA',
                    label: 'Your custom font here',
                    isDisabled: true,
                    tooltipText:
                        'Upload your own font files to Bananatag. Book a full demo to see how custom fonts display.',
                },
            ],
        },
        {
            label: 'Others',
            options: [
                { value: 'Andale Mono', label: 'Andale Mono' },
                { value: 'Arial', label: 'Arial' },
                { value: '"Arial Black"', label: 'Arial Black' }, // FIX: (FEED-3956) value should have quotes, because without it mjml replace it to 'Arial #000'
                { value: 'Book Antiqua', label: 'Book Antiqua' },
                { value: 'Comic Sans MS', label: 'Comic Sans MS' },
                { value: 'Courier New', label: 'Courier New' },
                { value: 'Georgia', label: 'Georgia' },
                { value: 'Helvetica', label: 'Helvetica' },
                { value: 'Impact', label: 'Impact' },
                { value: 'Tahoma', label: 'Tahoma' },
                { value: 'Terminal', label: 'Terminal' },
                { value: 'Times New Roman', label: 'Times New Roman' },
                { value: 'Trebuchet MS', label: 'Trebuchet MS' },
                { value: 'Verdana', label: 'Verdana' },
            ],
        },
    ],
    fontSize: [
        { value: '8px', label: '8px' },
        { value: '9px', label: '9px' },
        { value: '10px', label: '10px' },
        { value: '11px', label: '11px' },
        { value: '12px', label: '12px' },
        { value: '13px', label: '13px' },
        { value: '14px', label: '14px' },
        { value: '15px', label: '15px' },
        { value: '16px', label: '16px' },
        { value: '18px', label: '18px' },
        { value: '20px', label: '20px' },
        { value: '21px', label: '21px' },
        { value: '22px', label: '22px' },
        { value: '25px', label: '25px' },
        { value: '28px', label: '28px' },
        { value: '31px', label: '31px' },
    ],
    lineHeight: [
        { value: '1', label: '1' },
        { value: '1.2', label: '1.2' },
        { value: '1.5', label: '1.5' },
        { value: '1.7', label: '1.7' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
    ],
    align: [
        { value: 'left', label: 'Left' },
        { value: 'center', label: 'Center' },
        { value: 'right', label: 'Right' },
    ],
};
